import React from "react";
import { Moon, Sun } from "lucide-react";
import { cn } from "../../lib/utils";
import { useTheme } from "../../lib/theme";
import { useTranslation } from "../../i18n";

interface ThemeToggleProps {
  /** Render light-on-dark (for the colored header) vs dark-on-light. */
  onDark?: boolean;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ onDark = true }) => {
  const [mode, toggle] = useTheme();
  const { t } = useTranslation();
  const isDark = mode === "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={t("theme.toggle")}
      title={isDark ? t("theme.light") : t("theme.dark")}
      className={cn(
        "flex items-center justify-center rounded-lg p-2 transition-colors min-h-[40px] min-w-[40px]",
        onDark
          ? "text-white hover:bg-white/10"
          : "text-gray-700 hover:bg-gray-100 border border-gray-200"
      )}
    >
      {isDark ? (
        <Sun className="h-5 w-5 text-[#f5c542]" />
      ) : (
        <Moon className="h-5 w-5" />
      )}
    </button>
  );
};
